(function () {
  var screenEl = document.getElementById('torflux-loading-screen');
  if (!screenEl) return;

  var SESSION_KEY = 'torflux-loading-shown';
  var alreadyShown = false;
  try {
    alreadyShown = sessionStorage.getItem(SESSION_KEY) === '1';
  } catch (e) {}

  if (alreadyShown) {
    screenEl.remove();
    return;
  }

  try {
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch (e) {}

  var minDisplay = 700;
  var start = Date.now();

  function hide() {
    var elapsed = Date.now() - start;
    var wait = Math.max(minDisplay - elapsed, 0);
    setTimeout(function () {
      screenEl.classList.add('is-hidden');
      screenEl.addEventListener('transitionend', function () {
        screenEl.remove();
      });
    }, wait);
  }

  if (document.readyState === 'complete') {
    hide();
  } else {
    window.addEventListener('load', hide);
  }
})();
